import React from 'react';
import DownloadApps from "../assets/DownloadApps.svg"
import './DownloadAppSection.css';

const DownloadAppSection = () => {
  return (
    <section id="download-app" className="download-app-section">
      <div className="section-container">
        <div className="download-grid">
          {/* LEFT: content (title + two promo cards) */}
          <div className="download-content">
            <h2 className="section-title">Download the App</h2>

            <div className="download-card">
              <div className="download-card-inner">
                <h3 className="download-subtitle">Rider App:</h3>
                <div className="app-buttons">
                  <a href="#" className="app-store-btn" aria-label="Google Play">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
                  </a>
                  <a href="#" className="app-store-btn" aria-label="App Store">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on App Store" />
                  </a>
                </div>
                <div>
                  <p>First ride <strong>FREE</strong> (up to $15 value) with code <strong className="promo-code">WELCOME2025</strong></p>
                </div>
              </div>
            </div>

            <div className="download-card">
              <div className="download-card-inner">
                <h3 className="download-subtitle">Driver App:</h3>
                <div className="app-buttons">
                  <a href="#" className="app-store-btn" aria-label="Driver Google Play">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
                  </a>
                  <a href="#" className="app-store-btn" aria-label="Driver App Store">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on App Store" />
                  </a>
                </div>
                <div>
                  <p>Earn <strong>$250</strong> bonus after completing 50 rides in your first month</p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT: image on patterned background */}
          <div className="download-image">
            <div className="download-image-frame">
              <img
                src={DownloadApps}
                alt="Download App"
                className="promo-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadAppSection;
